export default { sha: '882781a1ed89ee316f3380c91c9f1a60e0f84c01', buildNumber: 'undefined' }
